var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBflReverseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3333 19.2667C16.2643 20.3813 18.4439 20.9939 20.6727 21.0485H20.7697C23.2024 20.9876 25.5912 20.3873 27.7636 19.2909C30.4692 17.893 33.52 17.3039 36.5515 17.5939C37.8344 17.7221 39.1012 17.978 40.3333 18.3576C40.3333 18.0788 40.3333 17.8121 40.2727 17.5455C39.0842 17.2024 37.8671 16.9671 36.6364 16.8424C33.47 16.5393 30.2834 17.1581 27.4606 18.6242C25.386 19.6852 23.0991 20.2652 20.7697 20.3212H20.6848C18.5533 20.291 16.4656 19.7106 14.6242 18.6364C12.2743 17.2828 9.57051 16.6702 6.86667 16.8788C4.86598 17.0206 2.89309 17.4283 1 18.0909C1 18.3576 1 18.6364 1 18.9152C2.91817 18.2376 4.92114 17.8297 6.95152 17.703C9.51423 17.4552 12.0912 18.001 14.3333 19.2667Z",
    fill: "black",
    stroke: "#020202",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3333 24.8909C16.2611 26.0098 18.4439 26.615 20.6727 26.6485H20.7696C23.2023 26.5876 25.5911 25.9873 27.7636 24.8909C30.4706 23.4978 33.5212 22.913 36.5514 23.2061C37.651 23.3047 38.7387 23.5077 39.7999 23.8121C39.8605 23.5576 39.9211 23.3151 39.9696 23.0606C38.8745 22.7579 37.7551 22.5511 36.6242 22.4424C33.4656 22.1367 30.2856 22.7424 27.4605 24.1879C25.3869 25.253 23.1 25.8372 20.7696 25.897H20.6848C18.5543 25.8704 16.4667 25.2942 14.6242 24.2242C12.2787 22.8585 9.5723 22.2411 6.8666 22.4545C5.03467 22.5794 3.22404 22.9212 1.47266 23.4727C1.47266 23.7151 1.58175 23.9697 1.65447 24.2121C3.37486 23.655 5.15862 23.317 6.96357 23.2061C9.53442 23.0036 12.1058 23.5915 14.3333 24.8909Z",
    fill: "black",
    stroke: "#020202",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3332 13.6303C16.261 14.7492 18.4439 15.3544 20.6726 15.3879H20.7696C23.203 15.3327 25.5931 14.7321 27.7635 13.6303C30.4725 12.2431 33.5214 11.6585 36.5514 11.9455C37.4212 12.0298 38.284 12.1756 39.1332 12.3818C39.0362 12.0909 38.915 11.8 38.7938 11.5212C38.0778 11.3658 37.3534 11.2525 36.6241 11.1818C33.4643 10.8792 30.2841 11.4891 27.4605 12.9394C25.3859 14.0003 23.099 14.5803 20.7696 14.6364H20.6847C18.554 14.6002 16.4678 14.0202 14.6241 12.9515C12.2787 11.5858 9.57226 10.9684 6.86655 11.1818C5.33773 11.2844 3.82306 11.5403 2.34534 11.9455C2.22413 12.2364 2.11504 12.5273 2.01807 12.8303C3.59688 12.3584 5.22282 12.0617 6.86655 11.9455C9.46969 11.7228 12.0779 12.3114 14.3332 13.6303Z",
    fill: "black",
    stroke: "#020202",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3334 8.00606C16.2666 9.1122 18.4461 9.71645 20.6728 9.76363H20.7698C23.2025 9.70273 25.5913 9.10243 27.7637 8.00606C30.1524 6.79026 32.8054 6.18635 35.4849 6.24848L34.7698 5.47272C32.2417 5.54982 29.7605 6.17427 27.4971 7.30303C25.4225 8.36394 23.1356 8.94395 20.8062 9H20.7213C18.5908 8.97343 16.5032 8.39726 14.6607 7.32727C12.3152 5.96156 9.60883 5.34416 6.90313 5.55757H6.46676C6.20009 5.83636 5.94555 6.11515 5.70312 6.40606C6.11525 6.40606 6.52737 6.30909 6.91525 6.28485C9.50694 6.07123 12.1006 6.67303 14.3334 8.00606Z",
    fill: "black",
    stroke: "#020202",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6729 4.13939H20.7699C23.2043 4.08083 25.5945 3.47604 27.7638 2.3697C28.3456 2.12727 28.976 1.87273 29.5457 1.64242C29.2305 1.48485 28.9275 1.32727 28.6002 1.19394L27.4608 1.67879C25.3862 2.7397 23.0993 3.31971 20.7699 3.37576H20.685C18.5534 3.34551 16.4658 2.76514 14.6244 1.69091C14.1517 1.46061 13.6669 1.21818 13.1578 1C12.8305 1.13333 12.5153 1.26667 12.2002 1.42424C12.9275 1.70303 13.6063 2.04242 14.285 2.38182C16.2326 3.49579 18.4297 4.10031 20.6729 4.13939Z",
    fill: "black",
    stroke: "#020202",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3334 30.5152C16.2612 31.6341 18.444 32.2393 20.6728 32.2727H20.7697C23.2032 32.2175 25.5932 31.6169 27.7637 30.5152C30.4727 29.1279 33.5216 28.5434 36.5516 28.8303C36.9516 28.8303 37.3516 28.9273 37.7637 28.9879L38.1516 28.2848C37.6546 28.2 37.1576 28.1152 36.6485 28.0667C33.4888 27.764 30.3085 28.374 27.4849 29.8242C25.4103 30.8852 23.1234 31.4652 20.794 31.5212H20.7091C18.5775 31.491 16.4899 30.9106 14.6485 29.8364C12.3002 28.4778 9.5961 27.861 6.89096 28.0667C5.69954 28.1494 4.51626 28.3237 3.35156 28.5879L3.75156 29.2788C4.80176 29.0514 5.86726 28.9015 6.93944 28.8303C9.51837 28.6229 12.0989 29.2109 14.3334 30.5152Z",
    fill: "black",
    stroke: "#020202",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6728 37.9091H20.7697C23.2024 37.8482 25.5912 37.2479 27.7637 36.1515C29.4344 35.3419 31.215 34.7823 33.0485 34.4909C33.3879 34.2242 33.7152 33.9333 34.0425 33.6424C31.7529 33.8162 29.5183 34.4294 27.4607 35.4485C25.363 36.5287 23.0441 37.1095 20.6849 37.1455C18.5544 37.1189 16.4668 36.5427 14.6243 35.4727C12.4213 34.1921 9.89742 33.5695 7.35156 33.6788L8.21217 34.3818C10.3649 34.431 12.4704 35.0231 14.3334 36.103C16.2621 37.2261 18.4418 37.8471 20.6728 37.9091Z",
    fill: "black",
    stroke: "#020202",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBflReverseLogo);
export default __webpack_public_path__ + "static/media/bfl-reverse-Logo.6e421aea180a5c26066eaed449b6283b.svg";
export { ForwardRef as ReactComponent };